import { contentActionsService } from '../../../utils/ContentActionsService/ContentActionsService';
import { useEventSource } from '../../../utils/LocationContext';
import { useTranslation } from '../../../utils/useTranslation';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';
import { ActionButton } from '../PartnerRegistrationForm/styles';
import { PartnerType, PartnerTypeTabsProps } from './types';

export interface PartnerTypeTabProps {
    isSelected: boolean;
    onClick: () => void;
    text: string;
}

const PartnerTypeTab = ({ isSelected, onClick, text }: PartnerTypeTabProps) => (
    <ActionButton
        onClick={onClick}
        p={2}
        size="m"
        color="secondary"
        style={{
            backgroundColor: isSelected ? 'var(--color-primary)' : undefined,
        }}
    >
        <Typography
            textTransform="none"
            variant="caption"
            weight="bold"
            style={{
                color: isSelected ? 'var(--color-invert)' : 'var(--color-primary)',
            }}
        >
            {text}
        </Typography>
    </ActionButton>
);

export const PartnerTypeTabs = (props: PartnerTypeTabsProps) => {
    const { partnerType, onChange } = props;
    const { eventSource } = useEventSource();

    const t = useTranslation();

    const handleTabClick = (type: PartnerType) => {
        const oldPartnerType = partnerType;
        onChange(type);
        if (eventSource) {
            contentActionsService.trackPartnerTypeTabClick({
                partnerType: type,
                oldPartnerType: oldPartnerType,
                screen: eventSource,
            });
        }
    };

    return (
        <Flex spacing={1} direction="row">
            <PartnerTypeTab
                isSelected={partnerType === PartnerType.SE}
                onClick={() => handleTabClick(PartnerType.SE)}
                text={t('САМОЗАНЯТЫЙ')}
            />
            <PartnerTypeTab
                isSelected={partnerType === PartnerType.IE}
                onClick={() => handleTabClick(PartnerType.IE)}
                text={t('ИП')}
            />
            <PartnerTypeTab
                isSelected={partnerType === PartnerType.LLC}
                onClick={() => handleTabClick(PartnerType.LLC)}
                text={t('ООО')}
            />
        </Flex>
    );
};
